function compareFn(a, b) {
  if (a.createdAt < b.createdAt) {
    return -1;
  } else if (a.createdAt > b.createdAt) {
    return 1;
  } else {
    return 0;
  }
}

// Sorts and groups a list of activities.
// NOTE(@trevorfrese) removing sorting for UA v2, events are pre-sorted by backend
export function group(activities, shouldSort = true) {
  let sorted = activities;
  if (shouldSort) {
    sorted = [...activities].sort(compareFn).reverse();
  }
  const pending = sorted.filter(activity => activity.isPending);
  const completed = sorted.filter(activity => !activity.isPending);
  return {
    pending,
    completed
  };
}
export function groupByMonth(activities, shouldSort = true) {
  const {
    pending,
    completed
  } = group(activities, shouldSort);
  const byMonthYear = new Map();
  for (const activity of completed) {
    const year = activity.createdAt.getFullYear();
    const month = activity.createdAt.getMonth();
    const monthYear = `${year}-${month}`;
    if (!byMonthYear.has(monthYear)) {
      byMonthYear.set(monthYear, {
        date: new Date(Date.UTC(year, month, 10)),
        activities: []
      });
    }
    byMonthYear.get(monthYear)?.activities.push(activity);
  }
  const array = [];
  for (const [_, obj] of byMonthYear.entries()) {
    array.push(obj);
  }
  return {
    pending,
    completed: array
  };
}
export function groupByDay(activities, shouldSort = true) {
  const {
    pending,
    completed
  } = group(activities, shouldSort);
  const byDate = new Map();
  for (const activity of completed) {
    const year = activity.createdAt.getFullYear();
    const month = activity.createdAt.getMonth();
    const day = activity.createdAt.getDate();
    const key = `${year}-${month}-${day}`;
    if (!byDate.has(key)) {
      byDate.set(key, {
        date: activity.createdAt,
        activities: []
      });
    }
    byDate.get(key)?.activities.push(activity);
  }
  return {
    pending,
    completed: [...byDate.values()]
  };
}
export function groupCompletedActivitiesByDay(completedActivities) {
  const byDate = new Map();
  for (const activity of completedActivities) {
    const year = activity.createdAt.getFullYear();
    const month = activity.createdAt.getMonth();
    const day = activity.createdAt.getDate();
    const key = `${year}-${month}-${day}`;
    if (!byDate.has(key)) {
      byDate.set(key, {
        date: activity.createdAt,
        activities: []
      });
    }
    byDate.get(key)?.activities.push(activity);
  }
  return [...byDate.values()];
}